/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar source`)
};

const zh_hans1_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`头像来源`)
};

const zh_hant1_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`頭像來源`)
};

const fr_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source de l’avatar`)
};

const de_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar-Quelle`)
};

const ja_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバターの取得元`)
};

const ko_settings_avatar_source_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아바타 출처`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_avatar_source_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_avatar_source_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_avatar_source_label", locale)
	if (locale === "en") return en_settings_avatar_source_label(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_avatar_source_label(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_avatar_source_label(inputs)
	if (locale === "fr") return fr_settings_avatar_source_label(inputs)
	if (locale === "de") return de_settings_avatar_source_label(inputs)
	if (locale === "ja") return ja_settings_avatar_source_label(inputs)
	return ko_settings_avatar_source_label(inputs)
};